/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { ModelsBarberAppointmentOutput } from "../../entities/models/BarberAppointmentOutput";
import { z } from "zod/v4";

export const modelsBarberAppointmentOutputSchema = z.object({
    "actual_start_time": z.optional(z.string()),
"called_at": z.optional(z.string()),
"client_name": z.optional(z.string()),
"id": z.optional(z.int()),
"scheduled_start_time": z.optional(z.string()),
"service_id": z.optional(z.int()),
"status": z.optional(z.string())
    }) as unknown as z.ZodType<ModelsBarberAppointmentOutput>